"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const TheLongevityFrontier = React.memo(function TheLongevityFrontier() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const sectionClasses = "dark bg-background text-foreground relative min-h-screen flex flex-col overflow-hidden selection:bg-secondary selection:text-secondary-foreground";
  const btnBaseClass = "rounded-full tracking-wide font-default h-14 px-10 transition-all duration-500";
  return <section data-section-id="235160" id="discover-hidden-guizhou" className={sectionClasses}>
      <div className="flex-grow grid grid-cols-1 lg:grid-cols-12">
        <div className="col-span-1 lg:col-span-7 flex flex-col justify-center px-6 sm:px-12 lg:px-20 xl:px-32 py-32 lg:py-0 z-10 relative">
          <div className="max-w-3xl">
            <h1 ref={headlineRef} className={`font-default text-5xl md:text-7xl lg:text-[44px] leading-[1.05] font-bold tracking-tight transition-all duration-1000 ease-out ${isHeadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              Discover the Hidden <br className="hidden md:block" />
              <span className="text-secondary">Soul of Guizhou.</span>
            </h1>
            
            <p ref={textRef} className={`font-default text-xl md:text-2xl text-muted-foreground mt-8 max-w-2xl leading-relaxed font-light transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              Experience authentic nature and immersive ethnic culture led by local experts. 
              Your gateway to China's most breathtaking karst landscapes.
            </p>

            <div ref={ctaRef} className={`mt-12 flex flex-wrap gap-4 transition-all duration-1000 delay-400 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Button variant="default" size="lg" className={`${btnBaseClass} bg-secondary text-secondary-foreground hover:bg-secondary/90`} asChild>
                <Link to="#">Explore Tours</Link>
              </Button>
              <Button variant="outline" size="lg" className={`${btnBaseClass} border-foreground/40 bg-transparent text-foreground hover:bg-foreground/10`} asChild>
                <Link to="#">Custom Itinerary</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="col-span-1 lg:col-span-5 relative h-[60vh] lg:h-auto overflow-hidden bg-primary" style={{
        contain: 'layout'
      }}>
          <div className="absolute inset-0 bg-primary/40 mix-blend-multiply z-10 pointer-events-none"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:bg-gradient-to-l lg:from-transparent lg:to-background z-10 pointer-events-none"></div>
          
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/guizhou_karst_mountains_hero.png" alt="Breathtaking karst mountain peaks and lush green valleys in Guizhou, China - authentic nature and scenic landscapes" loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center filter contrast-110 saturate-[0.9] animate-[pulse_10s_ease-in-out_infinite_alternate]" style={{
          animationDuration: '25s',
          willChange: 'transform'
        }} />
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 z-20 pointer-events-none">
        <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-mono">
          Scroll to Discover
        </span>
        <div className="w-[1px] h-16 bg-muted-foreground/20 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/3 bg-secondary animate-pulse"></div>
        </div>
      </div>
    </section>;
});
export default TheLongevityFrontier;